<template>
    <cms-block v-bind="$props" @block-selected="selectBlock">
        <div class="collapse-title" @click="toggle">
            <cms-component-text comp-id="question" :component="block.question" placeholder="Question" v-bind="componentProps">
                <template #append>
                    <i class="fas fa-fw" :class="!extended ? 'fa-chevron-down' : 'fa-chevron-up'"/>
                </template>
            </cms-component-text>
        </div>
        <div class="collapse-content" v-show="extended || isEditMode">
            <cms-component-text comp-id="answer" :component="block.answer" placeholder="Answer|Réponse" v-bind="componentProps"/>
        </div>
    </cms-block>
</template>

<script>
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";
import CmsComponentText from "@/components/editor/rendering/components/cms-component-text.vue";

// cms-block-faq-item #hot-reload-debug
export default {
    name: `cms-block-faq-item`,
    components: {CmsComponentText, CmsBlock},
    extends: CmsBlock,
    props: {
        active: {type: Boolean}
    },
    data() {
        return {
            extended: false
        }
    },
    mounted() {
        this.extended = this.active;
    },
    methods: {
        toggle() {
            if (!this.isEditMode) {
                this.extended = !this.extended;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.cms-block-faq-item {

}
</style>
